import React from 'react';
import '../template-file-css/document-file-template.css';


export const LSS_DiagnosticEvaluation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LSS_DiagnosticEvaluation' className='file-pdf-document'>
            <div className='file-template'>

                

                <h2>
                    DIAGNOSTIC EVALUATION UPDATE
                </h2>

                <p className='w-750'>
                    <span className='eleHeader'>Reason for update:</span>
                    <textarea id='txtReasonforupdate' name='txtReasonforupdate' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Date of last DE/DA:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtDateoflast' name='txtDateoflast' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    <textarea id='txtAdditionalinformation_1' name='txtAdditionalinformation_1' className='add-only'></textarea>
                </p>

                <h2>
                    PRESENTING PROBLEM
                </h2>

                <p className='w-750'>
                    <span className='eleHeader'>What led you to come in here today? What do you need help with? </span>
                    < textarea id='txtWhatledyou' placeholder='(symptoms functioning ability, precipitating event) ' name='txtWhatledyou' className='add-only'></textarea>

                    <span className='eleHeader'>What does client hope to get from treatment?  </span>
                    < textarea placeholder='(anticipated outcome)' id='txtWhatdoesclient' name='txtWhatdoesclient' className='add-only'></textarea>

                    <span className='eleHeader'>How severe, on a scale of 1 - 10 (with 10 being the most severe), do you rate your presenting problem?</span>
                    < textarea id='txtHowsevere' name='txtHowsevere' className='add-only'></textarea>
                </p>

         
                <h2>
                    UPDATED PSYCHIATRIC HISTORY
                </h2>

                <p className='w-750'>
                    <span className='eleHeader'>Diagnosis (in client's words, their explanations): </span>
                    < textarea id='txtDiagnosisinclient' name='txtDiagnosisinclient' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Most recent hospitalization:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbhospitalization_1' name='cbhospitalization_1' className='add-only' value='Last month' /> Last month<br /></td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbhospitalization_2' name='cbhospitalization_2' className='add-only' value='6 months  ' /> 6 months  <br /></td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbhospitalization_3' name='cbhospitalization_3' className='add-only' value='past year' /> past year<br /></td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbhospitalization_4' name='cbhospitalization_4' className='add-only' value='2 years  h' /> 2 years  <br /></td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbhospitalization_5' name='cbhospitalization_5' className='add-only' value='2 years plus' /> 2 years plus<br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Where? </span>
                    < textarea id='txtWhere' name='txtWhere' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Length of stay:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbLengthofstay_1' name='cbLengthofstay_1' className='add-only' value='1 - 2 weeks' /> 1 - 2 weeks <br /></td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbLengthofstay_2' name='cbLengthofstay_2' className='add-only' value='2 - 4 weeks' /> 2 - 4 weeks <br /></td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbLengthofstay_3' name='cbLengthofstay_3' className='add-only' value='month+' /> month+<br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Where? </span>
                    < textarea id='txtWhere' name='txtWhere' className='add-only'></textarea>

                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_2' name='txtAdditionalinformation_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Are you currently receiving Psychiatric or Community Mental Health treatment outside of agency?   </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNo' name='cbNo' className='add-only' value='No ' /> No  <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbYes' name='cbYes' className='add-only' value='Yes (complete ROI)' /> Yes (complete ROI) <br /></td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Where? </span>
                    < textarea id='txtWhere_1' name='txtWhere_1' className='add-only'></textarea>

                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_3' name='txtAdditionalinformation_3' className='add-only'></textarea>
                </p>

                <h2>
                    SUBSTANCE USE HISTORY
                </h2>
                <p className='w-750'>
                    <b>Severity Levels = Presence of the # of DSM criteria symptoms Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</b>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>TOBACCO</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_1' name='cbEver_1' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_1' name='cbNeverUsed_1' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_1' name='txtEver_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_1' name='txtAgeat_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_1' name='txtLastuse_1' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_1' name='txtFrequency' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_1' name='txtRoute_1' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea placeholder='(orally, intravenously, inhaled, intranasal, etc.)' id='txtModeofuse_1' name='txtModeofuse_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_1' name='cbUsedinthepast_1' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_1' name='cbSubstance_1' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_1' name='cbPersistent_1' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_1' name='cbGreatdeal_1' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_1' name='cbCraving_1' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_1' name='cbContinueduse_1' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_1' name='cbRecurrent_1' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_1' name='cbImportantsocial_1' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_1' name='cbRecurrentsubstance_1' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_1' name='cbContinuedusedespite_1' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_1' name='cbToleranceneedfor_1' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_1' name='cbWithdrawal_1' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_4' name='txtAdditionalinformation_4' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>ALCOHOL - beer, wine, liquor, etc. </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_2' name='cbEver_2' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_2' name='cbNeverUsed_2' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_2' name='txtEver_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_2' name='txtAgeat_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_2' name='txtLastuse_2' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_2' name='txtRoute_2' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_2' name='txtModeofuse_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_2' name='cbUsedinthepast_2' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_2' name='cbSubstance_2' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_2' name='cbPersistent_2' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_2' name='cbGreatdeal_2' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_2' name='cbCraving_2' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_2' name='cbContinueduse_2' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_2' name='cbRecurrent_2' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_2' name='cbImportantsocial_2' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_2' name='cbRecurrentsubstance_2' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_2' name='cbContinuedusedespite_2' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_2' name='cbToleranceneedfor_2' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_2' name='cbWithdrawal_2' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_5' name='txtAdditionalinformation_5' className='add-only'></textarea>
                </p>



                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>CANNABIS (marijuana, marijuana related products):  </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_3' name='cbEver_3' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_3' name='cbNeverUsed_3' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_3' name='txtEver_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_3' name='txtAgeat_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_3' name='txtLastuse_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_3' name='txtRoute_3' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_3' name='txtModeofuse_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_3' name='cbUsedinthepast_3' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_3' name='cbSubstance_3' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_3' name='cbPersistent_3' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_3' name='cbGreatdeal_3' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_3' name='cbCraving_3' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_3' name='cbContinueduse_3' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_3' name='cbRecurrent_3' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_3' name='cbImportantsocial_3' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_3' name='cbRecurrentsubstance_3' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_3' name='cbContinuedusedespite_3' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_3' name='cbToleranceneedfor_3' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_3' name='cbWithdrawal_3' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_6' name='txtAdditionalinformation_6' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>HALLUCINOGENS (LSD, ecstasy, Ketamine, mushrooms, etc.):  </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_4' name='cbEver_4' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_4' name='cbNeverUsed_4' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_4' name='txtEver_4' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_4' name='txtAgeat_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_4' name='txtLastuse_4' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_4' name='txtRoute_4' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_4' name='txtModeofuse_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_4' name='cbUsedinthepast_4' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_4' name='cbSubstance_4' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_4' name='cbPersistent_4' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_4' name='cbGreatdeal_4' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_4' name='cbCraving_4' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_4' name='cbContinueduse_4' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_4' name='cbRecurrent_4' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_4' name='cbImportantsocial_4' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_4' name='cbRecurrentsubstance_4' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_4' name='cbContinuedusedespite_4' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_4' name='cbToleranceneedfor_4' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_4' name='cbWithdrawal_4' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_7' name='txtAdditionalinformation_7' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>PHENCYCLIDINE (PCP):   </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_5' name='cbEver_5' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_5' name='cbNeverUsed_5' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_5' name='txtEver_5' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_5' name='txtAgeat_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_5' name='txtLastuse_5' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_5' name='txtRoute_5' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_5' name='txtModeofuse_5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_5' name='cbUsedinthepast_5' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_5' name='cbSubstance_5' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_5' name='cbPersistent_5' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_5' name='cbGreatdeal_5' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_5' name='cbCraving_5' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_5' name='cbContinueduse_5' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_5' name='cbRecurrent_5' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_5' name='cbImportantsocial_5' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_5' name='cbRecurrentsubstance_5' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_5' name='cbContinuedusedespite_5' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_5' name='cbToleranceneedfor_5' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_5' name='cbWithdrawal_5' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_8' name='txtAdditionalinformation_8' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>INHALANTS (glues, sprays, cans): </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_6' name='cbEver_6' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_6' name='cbNeverUsed_6' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_6' name='txtEver_6' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_6' name='txtAgeat_6' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_6' name='txtLastuse_6' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_6' name='txtFrequency_6' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_6' name='txtRoute_6' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_6' name='txtModeofuse_6' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_6' name='cbUsedinthepast_6' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_6' name='cbSubstance_6' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_6' name='cbPersistent_6' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_6' name='cbGreatdeal_6' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_6' name='cbCraving_6' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_6' name='cbContinueduse_6' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_6' name='cbRecurrent_6' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_6' name='cbImportantsocial_6' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_6' name='cbRecurrentsubstance_6' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_6' name='cbContinuedusedespite_6' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_6' name='cbToleranceneedfor_6' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_6' name='cbWithdrawal_6' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_9' name='txtAdditionalinformation_9' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>OPIOIDS (Heroin, Hydrocodone, Oxycodone, Morphine, Hydromorphone, Codeine, Meperidine, Fentanyl):  </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_7' name='cbEver_7' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_7' name='cbNeverUsed_7' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_7' name='txtEver_7' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_7' name='txtAgeat_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_7' name='txtLastuse_7' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_7' name='txtFrequency_7' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_7' name='txtRoute_7' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_7' name='txtModeofuse_7' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_7' name='cbUsedinthepast_7' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_7' name='cbSubstance_7' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_7' name='cbPersistent_7' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_7' name='cbGreatdeal_7' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_7' name='cbCraving_7' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_7' name='cbContinueduse_7' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_7' name='cbRecurrent_7' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_7' name='cbImportantsocial_7' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_7' name='cbRecurrentsubstance_7' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_7' name='cbContinuedusedespite_7' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_7' name='cbToleranceneedfor_7' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_7' name='cbWithdrawal_7' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_10' name='txtAdditionalinformation_10' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>SEDATIVE, HYPNOTIC, OR ANXIOLYTIC (Benzodiazepines: Xanax, Ativan, Valium, Klonopin; Barbiturates; Z drugs: Ambien, Lunesta, etc.):   </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_8' name='cbEver_8' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_8' name='cbNeverUsed_8' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_8' name='txtEver_8' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_8' name='txtAgeat_8' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_8' name='txtLastuse_8' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_8' name='txtFrequency_8' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_8' name='txtRoute_8' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_8' name='txtModeofuse_8' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_8' name='cbUsedinthepast_8' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_8' name='cbSubstance_8' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_8' name='cbPersistent_8' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_8' name='cbGreatdeal_8' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_8' name='cbCraving_8' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_8' name='cbContinueduse_8' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_8' name='cbRecurrent_8' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_8' name='cbImportantsocial_8' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_8' name='cbRecurrentsubstance_8' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_8' name='cbContinuedusedespite_8' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_8' name='cbToleranceneedfor_8' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_8' name='cbWithdrawal_8' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_11' name='txtAdditionalinformation_11' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>STIMULANTS (Caffeine, Cocaine, Methamphetamine, Ritalin, Adderall, etc.): </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_9' name='cbEver_9' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_9' name='cbNeverUsed_9' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_9' name='txtEver_9' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_9' name='txtAgeat_9' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_9' name='txtLastuse_9' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_9' name='txtFrequency_9' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_9' name='txtRoute_9' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_9' name='txtModeofuse_9' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_9' name='cbUsedinthepast_9' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_9' name='cbSubstance_9' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_9' name='cbPersistent_9' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_9' name='cbGreatdeal_9' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_9' name='cbCraving_9' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_9' name='cbContinueduse_9' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_9' name='cbRecurrent_9' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_9' name='cbImportantsocial_9' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_9' name='cbRecurrentsubstance_9' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_9' name='cbContinuedusedespite_9' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_9' name='cbToleranceneedfor_9' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_9' name='cbWithdrawal_9' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_12' name='txtAdditionalinformation_12' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>OTHER (unknown): </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOTHER_26' name='txtOTHER_26' className='add-only' /> </td>
                        <td className='w-750'> <span className='small'>Mild = 2 - 3, Moderate = 4 - 5, Severe = 6 or more symptoms</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEver_10' name='cbEver_10' className='add-only' value='Ever' /> Ever <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNeverUsed_10' name='cbNeverUsed_10' className='add-only' value='Never Used' /> Never Used <br /></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtEver_10' name='txtEver_10' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Age at 1st use:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Last use: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgeat_10' name='txtAgeat_10' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtLastuse_10' name='txtLastuse_10' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Frequency:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Route: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtFrequency_10' name='txtFrequency_10' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtRoute_10' name='txtRoute_10' placeholder='(orally, intravenously, inhaled, intranasal, etc.)' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mode of use (include amount): </span>
                    < textarea id='txtModeofuse_10' name='txtModeofuse_10' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUsedinthepast_10' name='cbUsedinthepast_10' className='add-only' value='Used in the past 12 months? (if checked, answer below):' /> Used in the past 12 months? (if checked, answer below): <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstance_10' name='cbSubstance_10' className='add-only' value='Substance is often taken in larger amounts or over a longer period than intended' /> Substance is often taken in larger amounts or over a longer period than intended <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPersistent_10' name='cbPersistent_10' className='add-only' value='Persistent desire or unsuccessful efforts to cut down or control use of substance' /> Persistent desire or unsuccessful efforts to cut down or control use of substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGreatdeal_10' name='cbGreatdeal_10' className='add-only' value='Great deal of time used to obtain and/or recover from its effects' /> Great deal of time used to obtain and/or recover from its effects <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCraving_10' name='cbCraving_10' className='add-only' value='Craving, or strong desire or urge to use substance' /> Craving, or strong desire or urge to use substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinueduse_10' name='cbContinueduse_10' className='add-only' value=' Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance' /> Continued use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects or the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrent_10' name='cbRecurrent_10' className='add-only' value='Recurrent use results in failure to fulfill major role obligations at work, school, or home' /> Recurrent use results in failure to fulfill major role obligations at work, school, or home <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbImportantsocial_10' name='cbImportantsocial_10' className='add-only' value='Important social, occupational, or recreational activities given up or reduced due to use' /> Important social, occupational, or recreational activities given up or reduced due to use <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRecurrentsubstance_10' name='cbRecurrentsubstance_10' className='add-only' value='Recurrent substance use in situations in which it is physically hazardous' /> Recurrent substance use in situations in which it is physically hazardous <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContinuedusedespite_10' name='cbContinuedusedespite_10' className='add-only' value='Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance' /> Continued use despite knowledge of having persistent or recurrent problem (physical and/or psychological) that is likely caused by or exacerbated by use of the substance <br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbToleranceneedfor_10' name='cbToleranceneedfor_10' className='add-only' value='Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance' /> Tolerance need for increased amounts of the substance to get the same effect or a diminished effect with continued use of the same amount of the substance <br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbWithdrawal_10' name='cbWithdrawal_10' className='add-only' value='Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms' /> Withdrawal (if applicable for the substance): characteristic withdrawal syndrome specified in the DSM 5 for the substance and/or use of a substance to relieve or avoid the symptoms <br /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_13' name='txtAdditionalinformation_13' className='add-only'></textarea>
                </p>

                <h2>
                    CAGE Questions
                </h2>

                <table>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Have you ever felt you should cut down on your drinking/drug use?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNo_1' name='cbNo_1' className='add-only' value='No' /> No <br /></td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbYes_1' name='cbYes_1' className='add-only' value='Yes' /> Yes<br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Have people annoyed you by criticizing your drinking/drug use?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNo_2' name='cbNo_2' className='add-only' value='No' /> No <br /></td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbYes_2' name='cbYes_2' className='add-only' value='Yes' /> Yes<br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Have you ever felt bad/guilty about your drug use?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNo_3' name='cbNo_3' className='add-only' value='No' /> No <br /></td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbYes_3' name='cbYes_3' className='add-only' value='Yes' /> Yes<br /></td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Have you ever had to drink/used drugs first thing in the morning to steady your nerves or help you to feel better?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNo_4' name='cbNo_4' className='add-only' value='No' /> No <br /></td>
                        <td className='w-350'>
                            <input type='checkbox' id='cbYes_4' name='cbYes_4' className='add-only' value='Yes' /> Yes<br /></td>
                    </tr>

                </table>

                <h2>
                    TREATMENT HISTORY
                </h2>

                <table>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>Treatment History</span> </td>
                        <td className='w-50'> <span className='eleHeader'>No</span> </td>
                        <td className='w-50'> <span className='eleHeader'>Yes</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Where</span> </td>
                        <td className='w-150'> <span className='eleHeader'>When</span> </td>
                        <td className='w-150'> <span className='eleHeader'>How long</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <span className='text'>Outpatient </span> </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbNo_5' name='cbNo_5' className='add-only' value='No' /> No <br /></td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbYes_5' name='cbYes_5' className='add-only' value='Yes' /> Yes<br /></td>
                        <td className='w-200'> <input type='text' id='txtOutpatient_1' name='txtOutpatient_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtOutpatient_2' name='txtOutpatient_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtOutpatient_3' name='txtOutpatient_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-150'> <span className='text'>Inpatient</span> </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbNo_6' name='cbNo_6' className='add-only' value='No' /> No <br /></td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbYes_6' name='cbYes_6' className='add-only' value='Yes' /> Yes<br /></td>
                        <td className='w-200'> <input type='text' id='txtInpatient_1' name='txtInpatient_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtInpatient_2' name='txtInpatient_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtInpatient_3' name='txtInpatient_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-150'> <span className='text'>Detox unit</span> </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbNo_7' name='cbNo_7' className='add-only' value='No' /> No <br /></td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbYes_7' name='cbYes_7' className='add-only' value='Yes' /> Yes<br /></td>
                        <td className='w-200'> <input type='text' id='txtDetoxunit_1' name='txtDetoxunit_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDetoxunit_2' name='txtDetoxunit_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtDetoxunit_3' name='txtDetoxunit_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-150'> <span className='text'>AA/NA/CA, etc.</span> </td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbNo_8' name='cbNo_8' className='add-only' value='No' /> No <br /></td>
                        <td className='w-50'>
                            <input type='checkbox' id='cbYes_8' name='cbYes_8' className='add-only' value='Yes' /> Yes<br /></td>
                        <td className='w-200'> <input type='text' id='txtetc_1' name='txtetc_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtetc_2' name='txtetc_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtetc_3' name='txtetc_3' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Do you have a sponsor?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNo_8' name='cbNo_8' className='add-only' value='No' /> No <br /></td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbYes_8' name='cbYes_8' className='add-only' value='Yes' /> Yes<br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Name & Phone Number: </span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtNamePhoneNumber' name='txtNamePhoneNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_14' name='txtAdditionalinformation_14' className='add-only'></textarea>

                    <span className='eleHeader'>Client insight to SU issues: (how do you feel about your substance use? - get quote)  </span>
                    < textarea id='txtSUissues' name='txtSUissues' className='add-only'></textarea>

                    <span className='eleHeader'>Additional information: </span>
                    < textarea id='txtAdditionalinformation_15' name='txtAdditionalinformation_15' className='add-only'></textarea>

                    <span className='eleHeader'>**Clinical focus based on observation of client's insight level: </span>
                    <span className='small'>(choose one): </span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbNohistoryofdrug' name='cbNohistoryofdrug' className='add-only' value='No history of drug or alcohol use' /> No history of drug or alcohol use </td>
                        <td className='w-250'><input type='checkbox' id='cbEngagement' name='cbEngagement' className='add-only' value='Engagement (Client unaware of any problem)' /> Engagement (Client unaware of any problem) </td>
                        <td className='w-250'><input type='checkbox' id='cbPersuasion' name='cbPersuasion' className='add-only' value='Persuasion (Client thinks may have problem)' /> Persuasion (Client thinks may have problem)</td>
                    </tr>
                    <tr>
                        <td className='w-250'><input type='checkbox' id='cbActivetreatment' name='cbActivetreatment' className='add-only' value='Active treatment (Client recognizes has a problem)' /> Active treatment (Client recognizes has a problem) </td>
                        <td className='w-250'><input type='checkbox' id='cbRelapseprevention' name='cbRelapseprevention' className='add-only' value='Relapse prevention (Client focuses on sober strategies)' /> Relapse prevention (Client focuses on sober strategies) </td>
                    </tr>
                </table>

                <h2>UPDATED PSYCHOSOCIAL FUNCTIONING</h2>
                <p className='w-750'>
                    <b>
                        Since the completion of the last DE, has there been a change in:                                      Evidenced By /Signs/Symptoms/Behaviors
                    </b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Family Environment/Relationships/Special Circumstances </span>
                    <textarea id='txtFamilyEnvironment' name='txtFamilyEnvironment' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_1' name='cbNoneReported_1' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Housing </span>
                    <textarea id='txtHousing' name='txtHousing' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_2' name='cbNoneReported_2' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Employment/Income  </span>
                    <textarea id='txtEmployment' name='txtEmployment' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_3' name='cbNoneReported_3' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Military Information  </span>
                    <textarea id='txtMilitaryInformation ' name='txtMilitaryInformation' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_4' name='cbNoneReported_4' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Education/School Performance  </span>
                    <textarea id='txtEducation ' name='txtEducation' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_5' name='cbNoneReported_5' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Religious/Spirituality/Cultural Beliefs  </span>
                    <textarea id='txtReligious' name='txtReligious' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_6' name='cbNoneReported_6' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Behavior and Social Problems  </span>
                    <span className='small'>(problems with peers, authorities, teachers, etc.)  </span>
                    <textarea id='txtBehavior' name='txtBehavior' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_7' name='cbNoneReported_7' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Legal System Involvement </span>
                    <span className='small'>(Juvenile, DCFS, pending charges, Probation/Parole - include contact information) </span>
                    <textarea id='txtLegalSystemInvolvement ' name='txtLegalSystemInvolvement ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_8' name='cbNoneReported_8' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Interests/Hobbies  </span>
                    <textarea id='txtInterestsHobbies ' name='txtInterestsHobbies ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_9' name='cbNoneReported_9' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Psychosocial Stressors   </span>
                    <span className='small'>(current stressors)  </span>
                    <textarea id='txtPsychosocial ' name='txtPsychosocial ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_10' name='cbNoneReported_10' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Pertinent Health Issues/Medical Problems </span>
                    <span className='small'>(include PCP visits, any allergies and food/drug reactions) </span>
                    <textarea id='txtPertinentHealth ' name='txtPertinentHealth ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_11' name='cbNoneReported_11' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Current medications or changes to last reported medications  </span>
                    <span className='small'>(Prescribed by? Also include OTC medications, birth control, vitamins)  </span>
                    <textarea id='txtCurrentmedications' name='txtCurrentmedications ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_12' name='cbNoneReported_12' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Pregnancy/Births/Miscarriage/Abortions/Other  </span>
                    <textarea id='txtPregnancyBirths' name='txtPregnancyBirths ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_13' name='cbNoneReported_13' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other  </span>
                    <textarea id='txtOther_1' name='txtOther_1 ' className='add-only'></textarea>
                </p>

                <h2>UPDATED PSYCHIATRIC SYMPTOMS CHECKLIST INCLUDING FUNCTIONAL DOMAIN</h2>
                <p className='w-750'>
                    <b>
                        Since the completion of the last DE, has there been a change in:Evidenced By /Signs/Symptoms/Behaviors
                    </b>
                </p>


                <p className='w-750'>
                    <span className='eleHeader'>Nutritional/Eating Pattern Changes/Disorders  </span>
                    <textarea id='txtNutritional' name='txtNutritional ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_14' name='cbNoneReported_14' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Pain Management   </span>
                    <textarea id='txtPainManagement ' name='txtPainManagement ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_15' name='cbNoneReported_15' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Depressed Mood  </span>
                    <textarea id='txtDepressedMood  ' name='txtDepressedMood ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_16' name='cbNoneReported_16' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Bereavement Issues </span>
                    <textarea id='txtBereavementIssues  ' name='txtBereavementIssues ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_17' name='cbNoneReported_17' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Oppositional Behaviors </span>
                    <textarea id='txtOppositionalBehaviors  ' name='txtOppositionalBehaviors ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_18' name='cbNoneReported_18' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Inattention</span>
                    <textarea id='txtInattention ' name='txtInattention ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_19' name='cbNoneReported_19' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Impulsivity </span>
                    <textarea id='txtImpulsivity ' name='txtImpulsivity ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_20' name='cbNoneReported_20' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Hyperactivity</span>
                    <textarea id='txtHyperactivity' name='txtHyperactivity ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_21' name='cbNoneReported_21' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Disturbed Reality </span>
                    <span className='small'>(psychosis: hallucinations, delusions)</span>
                    <textarea id='txtDisturbedReality' name='txtDisturbedReality ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_22' name='cbNoneReported_22' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Mood Swings/Manic Episodes </span>
                    <textarea id='txtMoodSwings' name='txtMoodSwings ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_23' name='cbNoneReported_23' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Trauma</span>
                    <textarea id='txtTrauma' name='txtTrauma ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_24' name='cbNoneReported_24' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Anxiety/Panic Attacks/Obsessions/Compulsions </span>
                    <textarea id='txtAnxiety' name='txtAnxiety ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_25' name='cbNoneReported_25' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Survivorship/Victimization  </span>
                    <span className='small'>(physical, sexual, emotional, domestic violence, exploitation: to self or others)</span>
                    <textarea id='txtSurvivorship' name='txtSurvivorship ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_26' name='cbNoneReported_26' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Violence to others, objects, or places/Non-suicidal self-injury/Suicide Attempts </span>
                    <textarea id='txtViolencetoothers' name='txtViolencetoothers ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_27' name='cbNoneReported_27' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Anger Management  </span>
                    <textarea id='txtAngerManagement ' name='txtAngerManagement ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_28' name='cbNoneReported_28' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Addictive Behaviors  </span>
                    <span className='small'>(gambling, sexual, substance) </span>
                    <textarea id='txtAddictiveBehaviors ' name='txtAddictiveBehaviors ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_29' name='cbNoneReported_29' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other Addictive Behaviors  </span>
                    <textarea id='txtOtherAddictiveBehaviors  ' name='txtOtherAddictiveBehaviors ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_30' name='cbNoneReported_30' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Sleep Problems </span>
                    <textarea id='txtSleepProblems ' name='txtSleepProblems ' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_31' name='cbNoneReported_31' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Other</span>
                    <textarea id='txtOther_2' name='txtOther_2 ' className='add-only'></textarea>
                </p>


                <h2>
                    MENTAL STATUS EXAM
                </h2>

                <p className='w-750'>
                    <b>General Observations</b>
                </p>

                <table>
                    <tr><td className='w-750'> <span className='eleHeader'>Appearance </span> </td></tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbUnkept' name='cbUnkept' className='add-only' value='WUnkept' /> Unkept</td>
                        <td className='w-187'><input type='checkbox' id='cbWellgroomed' name='cbWellgroomed' className='add-only' value='Well-groomed' /> Well-groomed</td>
                        <td className='w-187'><input type='checkbox' id='cbDisheveled' name='cbDisheveled' className='add-only' value='Disheveled' />Disheveled</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Build </span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAverage_1' name='cbAverage_1' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='checkbox' id='cbThin' name='cbThin' className='add-only' value='Thin' /> Thin</td>
                        <td className='w-187'><input type='checkbox' id='cbOverweight' name='cbOverweight' className='add-only' value='Overweight' />Overweight</td>
                    </tr>


                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Demeanor </span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAverage_2' name='cbAverage_2' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='checkbox' id='cbHostile' name='cbHostile' className='add-only' value='THostile' /> Hostile</td>
                        <td className='w-187'><input type='checkbox' id='cbMistrustful' name='cbMistrustful' className='add-only' value='Mistrustful' />Mistrustful</td>
                        <td className='w-187'><input type='checkbox' id='cbWithdrawn' name='cbWithdrawn' className='add-only' value='Withdrawn' />Withdrawn </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPreoccupied' name='cbPreoccupied' className='add-only' value='Preoccupied' /> Preoccupied</td>
                        <td className='w-187'><input type='checkbox' id='cbDemanding' name='cbDemanding' className='add-only' value='cbPreoccupied' /> Demanding</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Eye Contact</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAverage_3' name='cbAverage_3' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='checkbox' id='cbAvoidant' name='cbAvoidant' className='add-only' value='Avoidant' /> Avoidant</td>
                        <td className='w-187'><input type='checkbox' id='cbIntense' name='cbIntense' className='add-only' value='Intense' />Intense</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Activity</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbAverage_4' name='cbAverage_4' className='add-only' value='Average' /> Average</td>
                        <td className='w-187'><input type='checkbox' id='cbAgitated' name='cbAgitated' className='add-only' value='Agitated' /> Agitated</td>
                        <td className='w-187'><input type='checkbox' id='cbSlowed_1' name='cbSlowed_1' className='add-only' value='Slowed' />Slowed</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Speech</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbClear' name='cbClear' className='add-only' value='Clear' /> Clear</td>
                        <td className='w-187'><input type='checkbox' id='cbSlurred' name='cbSlurred' className='add-only' value='Slurred' /> Slurred</td>
                        <td className='w-187'><input type='checkbox' id='cbSlowed_2' name='cbSlowed_2' className='add-only' value='Slowed' />Slowed</td>
                        <td className='w-187'><input type='checkbox' id='cbRapid' name='cbRapid' className='add-only' value='Rapid' /> Rapid</td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbPressured' name='cbPressured' className='add-only' value='Pressured' />Pressured</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleheader'>Comments:</span>
                    <textarea id='txtComments' name='txtComments' className='add-only'></textarea>
                </p>

                <h2>Thought Content</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Delusions</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbNoneReported_33' name='cbNoneReported_33' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbGrandiose' name='cbGrandiose' className='add-only' value=' Grandiose' />  Grandiose</td>
                        <td className='w-125'><input type='checkbox' id='cbPersecutory' name='cbPersecutory' className='add-only' value='Persecutory' />Persecutory</td>
                        <td className='w-125'><input type='checkbox' id='cbSomatic' name='cbSomatic' className='add-only' value='Somatic' />Somatic</td>
                        <td className='w-125'><input type='checkbox' id='cbBizarre' name='cbBizarre' className='add-only' value='Bizarre' /> Bizarre</td>
                        <td className='w-125'><input type='checkbox' id='cbNihilistic' name='cbNihilistic' className='add-only' value='Nihilistic' /> Nihilistic</td>
                        <td className='w-125'><input type='checkbox' id='cbReligious' name='cbReligious' className='add-only' value='Religious' /> Religious</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Other</span>
                    <textarea id='txtOther_3' name='txtOther_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_34' name='cbNoneReported_34' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbAutistic' name='cbAutistic' className='add-only' value='Autistic' />Autistic</td>
                        <td className='w-125'><input type='checkbox' id='cbObsessional' name='cbObsessional' className='add-only' value='Obsessional' />Obsessional</td>
                        <td className='w-125'><input type='checkbox' id='cbPhobic' name='cbPhobic' className='add-only' value='Phobic' />Phobic</td>
                        <td className='w-125'><input type='checkbox' id='cbGuilty' name='cbGuilty' className='add-only' value='Guilty' /> Guilty</td>
                        <td className='w-250'><input type='checkbox' id='cbIdeasofReference' name='cbIdeasofReference' className='add-only' value='Ideas of Reference' /> Ideas of Reference</td>

                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Self-Abuse</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_35' name='cbNoneReported_35' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSuicidalassesslethality' name='cbSuicidalassesslethality' className='add-only' value='Suicidal (assess lethality if present)' />Suicidal (assess lethality if present)</td>
                        <td className='w-125'><input type='checkbox' id='cbIntent' name='cbIntent' className='add-only' value=' Intent' /> Intent</td>
                        <td className='w-125'><input type='checkbox' id='cbPlan' name='cbPlan' className='add-only' value='Plan' />Plan</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbSelfmutilization' name='cbSelfmutilization' className='add-only' value='Self-mutilization: ' />Self-mutilization:</td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtSelfmutilization ' name='txtSelfmutilization' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Aggressive</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_36' name='cbNoneReported_36' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbAggressiveassesslethalityifpresent' name='cbAggressiveassesslethalityifpresent' className='add-only' value='Aggressive (assess lethality if present)' />Aggressive (assess lethality if present)</td>
                        <td className='w-125'><input type='checkbox' id='cbIntent_1' name='cbIntent_1' className='add-only' value=' Intent' /> Intent</td>
                        <td className='w-125'><input type='checkbox' id='cbPlan_1' name='cbPlan_1' className='add-only' value='Plan' />Plan</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_1' name='txtComments_1' className='add-only'></textarea>
                </p>

                <h2>Perceptions</h2>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Hallucinations</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_37' name='cbNoneReported_37' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbAuditory' name='cbAuditory' className='add-only' value=' Auditory' /> Auditory</td>
                        <td className='w-125'><input type='checkbox' id='cbVisual' name='cbVisual' className='add-only' value=' Visual' /> Visual</td>
                        <td className='w-125'><input type='checkbox' id='cbOlfactory' name='cbOlfactory' className='add-only' value='Olfactory' />Olfactory</td>
                        <td className='w-125'><input type='checkbox' id='cbGustatory' name='cbGustatory' className='add-only' value='Gustatory' />Gustatory</td>
                        <td className='w-125'><input type='checkbox' id='cbTactile' name='cbTactile' className='add-only' value='Tactile' />Tactile</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Other</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOther_4' name='txtOther_4' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'><input type='checkbox' id='cbNoneReported_38' name='cbNoneReported_38' className='add-only' value='None Reported' /> None Reported</td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='Delusions' /> Delusions</td>
                        <td className='w-250'><input type='checkbox' id='cbDepersonalization' name='cbDepersonalization' className='add-only' value='Depersonalization' /> Depersonalization</td>
                        <td className='w-125'><input type='checkbox' id='cbDerealization' name='cbDerealization' className='add-only' value='Derealization' />Derealization</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_2' name='txtComments_2' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Thought Problems</span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbLogical' name='cbLogical' className='add-only' value='Logical' /> Logical</td>
                        <td className='w-125'><input type='checkbox' id='cbCircumstantial' name='cbCircumstantial' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-125'><input type='checkbox' id='cbTangential' name='cbTangential' className='add-only' value='Tangential' />Tangential</td>
                        <td className='w-125'><input type='checkbox' id='cbLoose' name='cbLoose' className='add-only' value='Loose' /> Loose</td>
                        <td className='w-125'><input type='checkbox' id='cbRacing' name='cbRacing' className='add-only' value='Racing' />Racing</td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbIncoherent' name='cbIncoherent' className='add-only' value=' Incoherent' />  Incoherent</td>
                        <td className='w-125'><input type='checkbox' id='cbConcrete' name='cbConcrete' className='add-only' value='Concrete' />  Concrete</td>
                        <td className='w-125'><input type='checkbox' id='cbBlocked' name='cbBlocked' className='add-only' value='Blocked' />Blocked</td>
                        <td className='w-125'><input type='checkbox' id='cbFlightofIdeas' name='cbFlightofIdeas' className='add-only' value='Flight of Ideas' /> Flight of Ideas</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_3' name='txtComments_3' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Mood - How are you feeling today?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbEuthymic' name='cbEuthymic' className='add-only' value=' Euthymic' />Euthymic</td>
                        <td className='w-125'><input type='checkbox' id='cbDepressed' name='cbDepressed' className='add-only' value='Depressed' />Depressed</td>
                        <td className='w-125'><input type='checkbox' id='cbAnxious' name='cbAnxious' className='add-only' value='Anxious' />Anxious</td>
                        <td className='w-125'><input type='checkbox' id='cbEuphoric' name='cbEuphoric' className='add-only' value='Euphoric' /> Euphoric</td>
                        <td className='w-125'><input type='checkbox' id='cbIrritable' name='cbIrritable' className='add-only' value=' Irritable' />  Irritable</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_4' name='txtComments_4' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Affect</span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbFull' name='cbFull' className='add-only' value='Full' />Full</td>
                        <td className='w-125'><input type='checkbox' id='cbConstricted' name='cbConstricted' className='add-only' value='Constricted' />Constricted</td>
                        <td className='w-125'><input type='checkbox' id='cbFlat' name='cbFlat' className='add-only' value='Flat' />Flat</td>
                        <td className='w-125'><input type='checkbox' id='cbInappropriate' name='cbInappropriate' className='add-only' value=' Inappropriate' /> Inappropriate</td>
                        <td className='w-125'><input type='checkbox' id='cbLabile' name='cbLabile' className='add-only' value=' Labile' />  Labile</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_5' name='txtComments_5' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Behavior</span> </td>
                    </tr>

                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbCooperative' name='cbCooperative' className='add-only' value='Cooperative' />Cooperative</td>
                        <td className='w-125'><input type='checkbox' id='cbResistant' name='cbResistant' className='add-only' value='Resistant' />Resistant</td>
                        <td className='w-125'><input type='checkbox' id='cbAgitated' name='cbAgitated' className='add-only' value='Agitated' />Agitated</td>
                        <td className='w-125'><input type='checkbox' id='cbImpulsive' name='cbImpulsive' className='add-only' value=' Impulsive' />Impulsive</td>
                        <td className='w-125'><input type='checkbox' id='cbOversedated' name='cbOversedated' className='add-only' value=' Over-sedated' /> Over-sedated</td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbAssaultive' name='cbAssaultive' className='add-only' value=' Assaultive' /> Assaultive</td>
                        <td className='w-125'><input type='checkbox' id='cbAggressive' name='cbAggressive' className='add-only' value='Aggressive' />Aggressive</td>
                        <td className='w-125'><input type='checkbox' id='cbHyperactive' name='cbHyperactive' className='add-only' value='Hyperactive' />Hyperactive</td>
                        <td className='w-125'><input type='checkbox' id='cbRestles' name='cbRestles' className='add-only' value='Restles' /> Restles</td>
                        <td className='w-125'><input type='checkbox' id='cbLossofInterests' name='cbLossofInterests' className='add-only' value='Loss of Interests' />  Loss of Interests</td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbAnhedonia' name='cbAnhedonia' className='add-only' value='Anhedonia' />Anhedonia</td>
                        <td className='w-125'><input type='checkbox' id='cbAkathisia' name='cbAkathisia' className='add-only' value='Akathisia' />Akathisia</td>
                        <td className='w-125'><input type='checkbox' id='cbWithdrawn' name='cbWithdrawn' className='add-only' value='Withdrawn' /> Withdrawn</td>
                        <td className='w-125'><input type='checkbox' id='cbDystonia' name='cbDystonia' className='add-only' value='Dystonia' />Dystonia</td>
                        <td className='w-125'><input type='checkbox' id='cbTardiveDyskinesia' name='cbTardiveDyskinesia' className='add-only' value='Tardive Dyskinesia' /> Tardive Dyskinesia</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_6' name='txtComments_6' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Cognition</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Impairment of:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbNonereported' name='cbNonereported' className='add-only' value='None reported' />None reported</td>
                        <td className='w-125'><input type='checkbox' id='cbOrientation' name='cbOrientation' className='add-only' value='Orientation' />Orientation</td>
                        <td className='w-125'><input type='checkbox' id='cbMemory' name='cbMemory' className='add-only' value='Memory' /> Memory</td>
                        <td className='w-125'><input type='checkbox' id='cbAbilitytoAbstract' name='cbAbilitytoAbstract' className='add-only' value='Ability to Abstract' />Ability to Abstract</td>
                        <td className='w-125'><input type='checkbox' id='cbAttentionConcentration' name='cbAttentionConcentration' className='add-only' value=' Attention/ Concentration' /> Attention/ Concentration</td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>Intelligence Estimate:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbDD' name='cbDD' className='add-only' value='DD' />DD</td>
                        <td className='w-125'><input type='checkbox' id='cbBorderline' name='cbBorderline' className='add-only' value='Borderline' />Borderline</td>
                        <td className='w-125'><input type='checkbox' id='cbAverage' name='cbAverage' className='add-only' value='Average' />Average</td>
                        <td className='w-125'><input type='checkbox' id='cbAboveAverage' name='cbAboveAverage' className='add-only' value='Above Average' />Above Average</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_7' name='txtComments_7' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Insight/Judgment:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-125'><input type='checkbox' id='cbGood' name='cbGood' className='add-only' value='Good' />Good</td>
                        <td className='w-125'><input type='checkbox' id='cbFair' name='cbFair' className='add-only' value='Fair' />Fair</td>
                        <td className='w-125'><input type='checkbox' id='cbPoor ' name='cbPoor ' className='add-only' value='Poor ' />Poor </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Comments:</span>
                    <textarea id='txtComments_8' name='txtComments_8' className='add-only'></textarea>

                    <span className='eleHeader'>Elaboration of Active/Current Mental Status Findings</span>
                    <textarea id='txtElaborationofActive' name='txtElaborationofActive' className='add-only'></textarea>
                </p>

                <h2>NARRATIVE SUMMARY OF UPDATED INFORMATION </h2>

                <p className='w-750'>
                    <span className='eleHeader'>Narrative Summary of Updated Information:</span>
                    <textarea id='txtNarrativeSummary' name='txtNarrativeSummary' className='add-only'></textarea>
                </p>

                <h2>DIAGNOSTIC IMPRESSION </h2>

                <p className='w-750'>
                    <span className='eleHeader'>Diagnostic Impression (DSM 5 diagnosis and ICD 10 Code):</span>
                    <textarea id='txtDiagnosticImpression' name='txtDiagnosticImpression' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>RECOMMENDED SERVICES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbDiagnosticEvaluation' name='cbDiagnosticEvaluation' className='add-only' value='Diagnostic Evaluation    (Includes Initial Diagnostic Evaluation and Diagnostic Update)' />Diagnostic Evaluation   (Includes Initial Diagnostic Evaluation and Diagnostic Update)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCPST' name='cbCPST' className='add-only' value='CPST    (Community Psychiatric Support Treatment)' />CPST    (Community Psychiatric Support Treatment)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbACT ' name='cbACT ' className='add-only' value='ACT    (Assertive Community Treatment)' />ACT    (Assertive Community Treatment)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPsychoeducation' name='cbPsychoeducation' className='add-only' value='Psychoeducation Support Services    (Includes Psychosocial Service Rehabilitation, Therapeutic Behavioral Services - individual, families, and crisis)' />Psychoeducation Support Services    (Includes Psychosocial Service Rehabilitation, Therapeutic Behavioral Services - individual, families, and crisis) </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPsychotherapy' name='cbPsychotherapy ' className='add-only' value='Psychotherapy    (Includes Psychotherapy for individuals, families, interactive complexity, and crisis)' />Psychotherapy    (Includes Psychotherapy for individuals, families, interactive complexity, and crisis) </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbPsychopharmacological ' name='cbPsychopharmacological' className='add-only' value='Psychopharmacological Services    (Includes Psychiatric Evaluation, Psychopharmacological Management Services)' />Psychopharmacological Services    (Includes Psychiatric Evaluation, Psychopharmacological Management Services)</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbSubstance ' name='cbSubstance' className='add-only' value='Substance Use Disorder Services    (Includes SUD Assessment; SUD Psychotherapy for individuals, groups, and families)' />Substance Use Disorder Service    (Includes SUD Assessment; SUD Psychotherapy for individuals, groups, and families)</td>
                    </tr>
                </table>


                <table>

                    <tr>
                        <td className='w-750'><span className='eleHeader'>ASAM LEVEL OF CARE</span></td>
                    </tr>
                </table>

                <p className='w-750'><b>ASAM Level</b> </p>

                <table>
                    <tr>
                        <td className='w-187'>Level 1 Outpatient Relapse Prevention and close treatment episode </td>
                        <td className='w-187'>Level 2.1 Intensive Outpatient Practice recovery skills in client's own environment</td>
                        <td className='w-187'>Level 3.1 Halfway House Focus of SUD treatment</td>
                        <td className='w-187'>Level 3.5 Non-Medical Residential Focus on motivation and preparation for treatment & transition to clinical environment</td>
                    </tr>
                </table>

                <p className='w-750'><b>1.Acute Intoxication and/or Withdrawal </b></p>

                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbNowithdrawal_1 ' name='cbNowithdrawal_1' className='add-only' value='No withdrawal needs or needs can be safely managed at this level' />No withdrawal needs or needs can be safely managed at this level</td>
                        <td className='w-187'><input type='checkbox' id='cbNowithdrawal_2 ' name='cbNowithdrawal_2' className='add-only' value='No withdrawal needs or needs can be safely managed at this level' />No withdrawal needs or needs can be safely managed at this level</td>
                        <td className='w-187'><input type='checkbox' id='cbNosigns ' name='cbNosigns' className='add-only' value='No signs or symptoms of withdrawal, or withdrawal that can be managed at low intensity outpatient level' />No signs or symptoms of withdrawal, or withdrawal that can be managed at low intensity outpatient level</td>
                        <td className='w-187'><input type='checkbox' id='cbMinimalrisk ' name='cbMinimalrisk' className='add-only' value='Minimal risk of severe withdrawal, or if withdrawal is present, can be managed at a social setting detox level' />Minimal risk of severe withdrawal, or if withdrawal is present, can be managed at a social setting detox level</td>
                    </tr>

                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: :</span>
                    <textarea id='txtAdditionalinformation_16' name='txtAdditionalinformation_16' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbNofurther_1 ' name='cbNofurther_1' className='add-only' value='No further treatments are required for this client' />No further treatments are required for this client</td>
                    </tr>
                </table>

                <p className='w-750'><b>2.Biomedical Conditions and Complications </b></p>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbsufficientstable ' name='cbsufficientstable' className='add-only' value='None or sufficient stable' />None or sufficient stable</td>
                        <td className='w-187'><input type='checkbox' id='cbIfpresent' name='cbIfpresent' className='add-only' value='If present, are stable or are receiving concurrent attention and wont interfere with treatment' />If present, are stable or are receiving concurrent attention and won't interfere with treatment</td>
                        <td className='w-187'><input type='checkbox' id='cbStableandno ' name='cbStableandno' className='add-only' value='1' />Stable and no medical monitoring needed, or doesn't warrant inpatient, but needs medical monitoring</td>
                        <td className='w-187'><input type='checkbox' id='cbIfpresentstable ' name='cbIfpresentstable' className='add-only' value='If present, stable and can self-administer meds or severe enough to warrant medical monitoring but not in need of inpatient treatment' />If present, stable and can self-administer meds or severe enough to warrant medical monitoring but not in need of inpatient treatment</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: :</span>
                    <textarea id='txtAdditionalinformation_17' name='txtAdditionalinformation_17' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbNofurther_2 ' name='cbNofurther_2' className='add-only' value='No further treatments are required for this client' />No further treatments are required for this client</td>
                    </tr>
                </table>

                <p className='w-750'><b>3.Emotional/Behavioral or Cognitive Conditions and Complications </b></p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNoneorverystable ' name='cbNoneorverystable' className='add-only' value='None or very stable (cognitively able to participate and no risk of harm)' />None or very stable (cognitively able to participate and no risk of harm)</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbIfpresentmildseverity ' name='cbIfpresentmildseverity ' className='add-only' value='If present, mild severity and needs outpatient monitoring to minimize distractions from recovery' />If present, mild severity and needs outpatient monitoring to minimize distractions from recovery</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbStableorifdistracting' name='cbStableorifdistracting' className='add-only' value='Stable or if distracting, can respond to the level of 24-hour structure in this program' />Stable or if distracting, can respond to the level of 24-hour structure in this program</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMildtoModerate ' name='cbMildtoModerate' className='add-only' value='1' />Mild to Moderate severity; needs structure to focus on recovery. Treatment should respond to the client's cognitive deficits. Difficulties with mood, behavioral or cognitive symptoms that are troublesome but do not meet criteria for a mental disorder.Meets criteria for both Mental Disorder & Substance Dependence Disorder</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: :</span>
                    <textarea id='txtAdditionalinformation_18' name='txtAdditionalinformation_18' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbNofurther_3' name='cbNofurther_3' className='add-only' value='No further treatments are required for this client' />No further treatments are required for this client</td>
                    </tr>
                </table>

                <p className='w-750'><b>4.Readiness to Change </b></p>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbWillingto ' name='cbWillingto' className='add-only' value='Willing to cooperate or is ambivalent and needs motivating and monitoring strategies' />Willing to cooperate or is ambivalent and needs motivating and monitoring strategies</td>
                        <td className='w-187'><input type='checkbox' id='cbResistancehigh' name='cbResistancehigh ' className='add-only' value='Resistance high enough to require structured program but not so high as to render outpatient treatment ineffective' />Resistance high enough to require structured program but not so high as to render outpatient treatment ineffective</td>
                        <td className='w-187'><input type='checkbox' id='cbmotivationandsupport' name='cbmotivationandsupport' className='add-only' value='Willing to cooperate with residential, but externalizes problems and needs this level structure, motivation and support' />Willing to cooperate with residential, but externalizes problems and needs this level structure, motivation and support</td>
                        <td className='w-187'><input type='checkbox' id='cbHaslittleawareness ' name='cbHaslittleawareness' className='add-only' value='Has little awareness & needs interventions available only at level III.3 to engage & stay in treatment; or there is high severity in this dimension but not in others. The client therefore needs a Level I motivational enhancement program' />Has little awareness & needs interventions available only at level III.3 to engage & stay in treatment; or there is high severity in this dimension but not in others. The client therefore needs a Level I motivational enhancement program</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: :</span>
                    <textarea id='txtAdditionalinformation_19' name='txtAdditionalinformation_19' className='add-only'></textarea>
                </p>

                <p className='w-750'><b>6.Recovery Environment</b></p>
                <table>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSupportiverecovery' name='cbSupportiverecovery' className='add-only' value='Supportive recovery environment or willingness to obtain such or supports need professional interventions' />Supportive recovery environment or willingness to obtain such or supports need professional interventions</td>
                        <td className='w-187'><input type='checkbox' id='cbLackssocial' name='cbLackssocial' className='add-only' value='1' />Lacks social contacts aren't conductive to recovery, but with structure or support of an IOP outpatient setting, the patient can cope</td>
                        <td className='w-187'><input type='checkbox' id='cbHasausing' name='cbHasausing' className='add-only' value='Has a using, unsupportive social network, or lacks a social network, requiring this level of 24-hour support' />Has a using, unsupportive social network, or lacks a social network, requiring this level of 24-hour support </td>
                        <td className='w-187'><input type='checkbox' id='cbEnvironmentis' name='cbEnvironmentis' className='add-only' value='Environment is dangerous & client needs 24-hour structure to learn to cope' />Environment is dangerous & client needs 24-hour structure to learn to cope </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional information: :</span>
                    <textarea id='txtAdditionalinformation_20' name='txtAdditionalinformation_20' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbNofurther_4' name='cbNofurther_4' className='add-only' value='No further treatments are required for this client' />No further treatments are required for this client</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>ASAM Recommended Level of Care</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbOutpatient' name='cbOutpatient' className='add-only' value='Level 1 Outpatient' />Level 1 Outpatient</td>
                        <td className='w-187'><input type='checkbox' id='cbIntensive' name='cbIntensive' className='add-only' value='Level 2.1 Intensive Outpatient' />Level 2.1 Intensive Outpatient</td>
                        <td className='w-187'><input type='checkbox' id='cbResidentialSupport ' name='cbResidentialSupport' className='add-only' value='Level 3.1 Intensive Outpatient w/Residential Support' />Level 3.1 Intensive Outpatient w/Residential Support</td>
                        <td className='w-187'><input type='checkbox' id='cbNonMedical ' name='cbNonMedical ' className='add-only' value='Level 3.5 Non-Medical Community Residential' />Level 3.5 Non-Medical Community Residential</td>
                    </tr>

                    <tr>
                        <td className='w-750'> <span className='eleHeader'>STRENGTHS/ASSETS/RESOURCES</span> </td>
                    </tr>
                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbStrong' name='cbStrong' className='add-only' value='Strong support system' />Strong support system</td>
                        <td className='w-187'><input type='checkbox' id='cbFlexible' name='cbFlexible' className='add-only' value='Flexible' />Flexible</td>
                        <td className='w-187'><input type='checkbox' id='cbDecisive ' name='cbDecisive' className='add-only' value='Decisive' />Decisive</td>
                        <td className='w-187'><input type='checkbox' id='cbFlexible ' name='cbFlexible' className='add-only' value='Flexible' />Flexible</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbResourceful' name='cbResourceful' className='add-only' value='Resourceful' />Resourceful</td>
                        <td className='w-187'><input type='checkbox' id='cbTeamplayer' name='cbTeamplayer' className='add-only' value='Team player' />Team player</td>
                        <td className='w-187'><input type='checkbox' id='cbIndependent' name='cbIndependent' className='add-only' value='Independent' />Independent</td>
                        <td className='w-187'><input type='checkbox' id='cbRespectsself ' name='cbRespectsself' className='add-only' value='Respects self' />Respects self</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbInsightful' name='cbInsightful' className='add-only' value='Insightful' />Insightful</td>
                        <td className='w-187'><input type='checkbox' id='cbCommitted' name='cbCommitted' className='add-only' value='Committed' />Committed</td>
                        <td className='w-187'><input type='checkbox' id='cbCompassionate' name='cbCompassionate' className='add-only' value=' Compassionate' /> Compassionate</td>
                        <td className='w-187'><input type='checkbox' id='cbTransparent ' name='cbTransparent' className='add-only' value='Transparent' />Transparent</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbIntelligent' name='cbIntelligent' className='add-only' value='Intelligent' /> Intelligent</td>
                        <td className='w-187'><input type='checkbox' id='cbLogical' name='cbLogical' className='add-only' value='Logical' />Logical</td>
                        <td className='w-187'><input type='checkbox' id='cbCaring' name='cbCaring' className='add-only' value='Caring' /> Caring</td>
                        <td className='w-187'><input type='checkbox' id='cbSenseofhumor' name='cbSenseofhumor' className='add-only' value='Sense of humor' />Sense of humor</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbResilient' name='cbResilient' className='add-only' value='Resilient' />Resilient</td>
                        <td className='w-187'><input type='checkbox' id='cbOrganized' name='cbOrganized' className='add-only' value='Organized' />Organized</td>
                        <td className='w-187'><input type='checkbox' id='cbInternalstrength' name='cbInternalstrength' className='add-only' value='Internal strength' /> Internal strength</td>
                        <td className='w-187'><input type='checkbox' id='cbCurious' name='cbCurious' className='add-only' value='Curious' />Curious</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbStrongwilled' name='cbStrongwilled' className='add-only' value='Strong-willed' />Strong-willed</td>
                        <td className='w-187'><input type='checkbox' id='cbCanmultitask' name='cbCanmultitask' className='add-only' value='Can multi-task' />Can multi-task</td>
                        <td className='w-187'><input type='checkbox' id='cbDiplomatic' name='cbDiplomatic' className='add-only' value='Diplomatic' /> Diplomatic</td>
                        <td className='w-187'><input type='checkbox' id='cbEmployable' name='cbEmployable' className='add-only' value='Employable' />Employable</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSelfsufficient' name='cbSelfsufficient' className='add-only' value='Self-sufficient' />Self-sufficient</td>
                        <td className='w-187'><input type='checkbox' id='cbExpressive' name='cbExpressive' className='add-only' value='Expressive' />Expressive</td>
                        <td className='w-187'><input type='checkbox' id='cbCreative' name='cbCreative' className='add-only' value='Creative' />Creative</td>
                        <td className='w-187'><input type='checkbox' id='cbDisciplined' name='cbDisciplined' className='add-only' value='Disciplined' />Disciplined</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbSurvivor' name='cbSurvivor' className='add-only' value=' Survivor' /> Survivor</td>
                        <td className='w-187'><input type='checkbox' id='cbGoodsocialskills' name='cbGoodsocialskills' className='add-only' value='Good social skills' />Good social skills</td>
                        <td className='w-187'><input type='checkbox' id='cbEducated' name='cbEducated' className='add-only' value='Educated' />Educated</td>
                        <td className='w-187'><input type='checkbox' id='cbHonest' name='cbHonest' className='add-only' value='Honest' />Honest</td>
                    </tr>

                    <tr>
                        <td className='w-187'><input type='checkbox' id='cbGoaloriented' name='cbGoaloriented' className='add-only' value=' Goal-oriented' />Goal-oriented</td>
                        <td className='w-187'><input type='checkbox' id='cbEmotionalcontrol' name='cbEmotionalcontrol' className='add-only' value='Emotional control' />Emotional control</td>
                        <td className='w-250'><input type='checkbox' id='cbEnjoyslearningnewthings' name='cbEnjoyslearningnewthings' className='add-only' value='Enjoys learning new things' />Enjoys learning new things</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'> SKILLS DEFICITS/SKILLS TRAINING/COMMUNITY SUPPORT NEEDS</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='small'>(check all applicable skills deficits, skills training, and/or community support needs identified)</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTreatmentplanning' name='cbTreatmentplanning' className='add-only' value='Treatment planning. Participating in and utilizing strengths-based treatment/planning which may include assisting the individual and family members or other collaterals with identifying strengths and needs' />Treatment planning. Participating in and utilizing strengths-based treatment/planning which may include assisting the individual and family members or other collaterals with identifying strengths and needs</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbIdentificationofstrategie' name='cbIdentificationofstrategie' className='add-only' value='Identification of strategies or treatment options. Assisting the individual and family members or other collaterals to identify strategies or treatment options associated with the individuals mental illness' />Identification of strategies or treatment options. Assisting the individual and family members or other collaterals to identify strategies or treatment options associated with the individuals mental illness</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbCrisisprevention' name='cbCrisisprevention' className='add-only' value='Crisis prevention and amelioration. Assisting the individual with effectively responding to or avoiding identified precursors or triggers that would risk their remaining in a community setting or that result in functional impairments, including assisting the individual and family members or other collaterals with identifying a potential psychiatric or personal crisis, developing a crisis management plan, and/or, as appropriate, seeking other supports to restore stability and functioning.' />Crisis prevention and amelioration. Assisting the individual with effectively responding to or avoiding identified precursors or triggers that would risk their remaining in a community setting or that result in functional impairments, including assisting the individual and family members or other collaterals with identifying a potential psychiatric or personal crisis, developing a crisis management plan, and/or, as appropriate, seeking other supports to restore stability and functioning.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTreatmentplanning' name='cbTreatmentplanning' className='add-only' value='Restoration of social skills. Rehabilitation and support with the restoration of social and interpersonal skills to increase community tenure enhance personal relationships, establish support networks, increase community awareness, develop coping strategies and promote effective functioning in the individuals social environment including home, work, and school.' />Restoration of social skills. Rehabilitation and support with the restoration of social and interpersonal skills to increase community tenure enhance personal relationships, establish support networks, increase community awareness, develop coping strategies and promote effective functioning in the individual's social environment including home, work, and school.</td>
                    </tr>
                    <tr>
                        <td className='w-750'><input type='checkbox' id='cbTreatmentplanning' name='cbTreatmentplanning' className='add-only' value=' Developing and providing solution focused interventions and emotional and behavioral management drawn from evidence-based psychotherapeutic treatments' /> Developing and providing solution focused interventions and emotional and behavioral management drawn from evidence-based psychotherapeutic treatments</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>As Evidenced By </span>
                    <span className='small'>(describe the specific skill deficits or areas where improvement is needed): </span>
                    <textarea id='txtAsEvidencedBy' name='txtAsEvidencedBy' className='add-only'></textarea>
                </p>

            </div>
        </form >

    )
}